import styled from 'styled-components';

export default styled.div`
  font-weight: 300;
  font-size: 2rem;
  line-height: 4rem;
  position: relative;
  top: -4rem;
  max-width: calc(100% - 6rem);
`;
